<!--suppress UnnecessaryLabelJS -->
<template>
	<v-data-table
		v-model="selected"
		:show-select="isSurveyor || isManager"
		:sort-by="isSurveyor ? 'start_date' : 'created_at'"
		:sort-desc="!isSurveyor"
		:headers="headers"
		:footer-props="{ 'items-per-page-options': [5, 10, 20, 30, 40, -1] }"
		:multi-sort="false"
		:items="measurements"
		:loading="loading"
		class="elevation-1"
		:single-expand="false"
		:expanded.sync="expanded"
		show-expand
		:height="height"
		fixed-header
		id="mytable"
		mobile-breakpoint="0"
		@update:options="pagination"
		:server-items-length="serverItemsLength"
	>
		<v-progress-linear
			slot="progress"
			color="blue"
			indeterminate
		></v-progress-linear>
		<template v-slot:top>
			<v-row>
				<c-col class="text-right pr-4">
					<h4>
						{{ $t("pages.measurementTable.msrmntCounter") }} : {{ serverTotal }}
					</h4>
				</c-col>
				<v-spacer />
				<c-col v-if="selected.length && isManager" class="text-left px-4">
					<v-btn color="primary" @click="openUpdateFormModal = true">
						<span> עדכון פרטים </span>
						<span> ({{ selected.length }} </span>
						<span> מדידות) </span>
					</v-btn>
					<update-form
						v-model="openUpdateFormModal"
						v-if="openUpdateFormModal"
						:selected="selected"
						@updated="getData"
					></update-form>
				</c-col>
				<v-col v-else-if="selected.length && isSurveyor" class="text-left">
					<v-btn
						:tooltip-text="$t('pages.measurementRow.surveyAcceptance')"
						color="primary"
						@click="$emit('accept', selected)"
					>
						<v-icon>mdi-checkbox-marked-circle</v-icon>
						<span> </span>
						<span>אישור מדידה</span>
					</v-btn>

					<v-btn
						:tooltip-text="$t('attributes.notSurveyed')"
						color="warning"
						@click="$emit('cancel', selected)"
					>
						<span>ביטול מדידה</span>
						<v-icon>mdi-close-circle</v-icon>
					</v-btn>
				</v-col>
			</v-row>
		</template>
		<template v-slot:item="{ headers, item, isSelected, select }">
			<measurement-row
				:item="item"
				:selected="isSelected"
				:is-open="checkIfOpen(item)"
				@open="open"
				@itemSelected="onSelectedRow"
				@edit="onEdit"
				@restore="onRestore"
				@delete="onDelete"
				@cancel="onCancel"
				@another="onAnother"
				@accept="$emit('accept', item)"
				@duplicate="$emit('duplicate', item)"
				@duplicateClient="$emit('duplicateClient', item)"
			/>
		</template>
		<template v-slot:expanded-item="{ headers, item }">
			<td :colspan="headers.length">
				<measurement-expended :item="item" :headers="headers" />
			</td>
		</template>
	</v-data-table>
</template>

<script>
	import FilterAble from "src/mixins/FilterAble";
	import { types } from "src/store/modules/Measurement.module";
	import SurveyorModule from "src/store/modules/Surveyor.module";
	import MeasurementExpended from "src/view/measurements/MeasureExpended";
	import StatusManager from "src/helpers/StatusManager";
	import MeasurementRow from "src/view/measurements/MeasurementRow";
	import UpdateForm from "src/view/measurements/UpdateForm";

	export default {
		name: "measurements-table",
		props: [],
		components: { UpdateForm, MeasurementRow, MeasurementExpended },
		mixins: [new FilterAble(types, true)],
		data() {
			return {
				openUpdateFormModal: false,
				singleExpand: false,
				expanded: [],
				selected: [],
				//sortBy: "start_date",
				loading: false,
				headers: [
					{
						text: this.$t("pages.measurementTable.orderDate"),
						value: "created_at",
					},
					{
						text: this.$t("attributes.customerName"),
						value: "orders_customer",
						width: "7%",
					},
					{
						text: this.$t("pages.orderTable.orderNum"),
						value: "orders_order_num",
					},
					{
						text: `HTM\\MNS\\${this.$t("pages.client.standard")}`,
						value: "recheck",
					},
					{
						text: this.$t("pages.projectForm.projectName"),
						value: "projects_name",
						width: "7%",
					},
					{ text: this.$t("pages.projectForm.city"), value: "projects_city" },
					{
						text: this.$t("pages.projectForm.address"),
						value: "projects_address",
					},
					{ text: this.$t("pages.orderForm.building"), value: "orders_building" },
					{
						text: this.$t("pages.orderForm.entrance"),
						value: "projects_entrance",
					},
					{
						text: this.$t("pages.orderForm.apartmentNum"),
						value: "order_apartment_num",
						width: "7%",
					},
					{
						text: this.$t("pages.orderTable.companyName"),
						value: "projects_client_name",
						width: "7%",
					},
					{
						text: this.$t("pages.projectForm.branch"),
						value: "projects_branch_name",
					},
					{ text: this.$t("pages.measurementTable.mustSurvey"), value: "areas" },
					{
						text: this.$t("pages.measurementTable.surveyer"),
						value: "surveyor_name",
					},
					{ text: this.$t("pages.orderFilter.matchedTo"), value: "start_date" },
					{
						text: this.$t("pages.statusSelect"),
						value: "status",
						sort: (a, b) => {
							const x = StatusManager.text(a).toLowerCase();
							const y = StatusManager.text(b).toLowerCase();
							return x < y ? -1 : x > y ? 1 : 0;
						},
					},
					{
						text: this.$t("pages.measurementTable.surveyDate"),
						value: "end_date",
					},
					{ text: this.$t("pages.measurementTable.actions"), value: "actions" },
				],
				showDialog: false,
				height: 200,
			};
		},
		computed: {
			isSurveyor() {
				return this.$store.getters.isSurveyor;
			},
			isManager() {
				return this.$store.getters.isManager;
			},
			users() {
				return this.$store.state.SurveyorModule.surveyors;
			},
			measurements() {
				return this.$store.state.MeasurementModule.measurements;
			},
			branchManager() {
				return this.$store.getters.isBranchManager;
			},
			serverTotal() {
				return this.$store.state.MeasurementModule.serverTotal;
			},
		},
		methods: {
			accept() {},
			onSelectedRow({ item, value }) {
				if (value) {
					this.selected.push(item);
				} else {
					this.$delete(this.selected, this.selected.indexOf(item));
				}
			},
			onAnother(item) {
				this.$emit("another", item);
			},

			onCancel(item) {
				this.$emit("cancel", item);
			},
			checkIfOpen(item) {
				return this.expanded.indexOf(item) > -1;
			},
			open(item) {
				let index = this.expanded.indexOf(item);
				if (index > -1) {
					this.expanded.splice(index, 1);
				} else {
					this.expanded.push(item);
				}
			},

			statusColor(item) {
				return "backgroundColor:" + StatusManager.color(item.status);
			},

			changeStatus(item) {
				this.$store.dispatch(types.UPDATE, item);
			},

			changeSurveyor(item) {
				this.$store.dispatch(types.UPDATE, item);
			},
			onEdit(item) {
				this.$emit("edit", item);
			},
			onDelete(item) {
				this.$store.dispatch(types.REMOVE, item);
			},
			async onRestore(item) {
				await this.$store.dispatch(types.RESTORE, item);
				this.$store.commit(types.REMOVE, item);
			},
		},
		created() {
			//delete row if isSurveyor
			if (this.isSurveyor) {
				this.headers.splice(
					this.headers.findIndex((item) => item.value === "surveyor_name"),
					1
				);
			} else {
				this.$store.dispatch(SurveyorModule.types.FETCH);
			}
		},
		mounted() {
			let defaultHeight =
				window.innerHeight - 100 - this.$el.getBoundingClientRect().y;
			this.height = defaultHeight < 255 ? 255 : defaultHeight;
		},
	};
</script>

<style scoped>
span {
  text-align: center;
  vertical-align: top;
  padding: 0;
}
</style>
